import COUNTRIES_ALL_DATA_JSON_EN from '../../assets/CountriesList/countriesOptionAllData.en.json';
import COUNTRIES_ALL_DATA_JSON_PT from '../../assets/CountriesList/countriesOptionAllData.pt.json';
import { CountriesAllDataAttributes, CountriesAllDataObject, CountriesApiObject } from '../../types/CountriesList';
import { CurrenciesAPIObject } from '../../types/Currencies';
import { DISABLED_COUNTRIES_IN_OPTION_LIST, COUNTRIES_ENABLE_FOR_MULTI_SELECT, PORTUGUESE_LANGUAGE } from '../../utils/Constants/Constants';
import { DialingCodeObj } from '../GetDialingCode/GetDialingCode';

export type OptionObject = {
    value: string,
    label: string,
    icon: string,
    displayName?: string
}
export type CountryListType = {
    options: OptionObject[]
}

export const GetPreferredLanguageCountriesOptions = () => {
    const userSelectedLanguage: string | null = localStorage.getItem('preferredLanguage');

    return userSelectedLanguage === PORTUGUESE_LANGUAGE ? COUNTRIES_ALL_DATA_JSON_PT : COUNTRIES_ALL_DATA_JSON_EN;
};

export const GetCountriesOptions = () => {
    let countriesOptionList: CountryListType = {
        options: []
    };

    const COUNTRIES_ALL_DATA_JSON: CountriesAllDataAttributes = GetPreferredLanguageCountriesOptions();

    COUNTRIES_ALL_DATA_JSON.options.forEach((countryData) => {
        let countryOptionData: OptionObject = {
            value: countryData.value,
            label: countryData.label,
            icon: countryData.icon
        };
        countriesOptionList.options.push(countryOptionData);

    });
    return countriesOptionList;
};

export const GetCountriesData = (referredFrom: string) => {
    const COUNTRIES_ALL_DATA_JSON: CountriesAllDataAttributes = GetPreferredLanguageCountriesOptions();

    let countryList: CountryListType;

    switch (referredFrom) {
        case 'setting':
            countryList = COUNTRIES_ALL_DATA_JSON;
            break;

        case 'setting_multi_select':
            const countriesEnable = COUNTRIES_ENABLE_FOR_MULTI_SELECT;
            const result = COUNTRIES_ALL_DATA_JSON.options.filter((data) => countriesEnable.includes(data.value));
            countryList = {
                options: result
            };
            break;

        default:
            countryList = COUNTRIES_ALL_DATA_JSON;
            break;
    }
    return countryList;
};

export const GetCountriesDataWithDefaultLanguage = () => {
    return COUNTRIES_ALL_DATA_JSON_EN;
};

export const GetCountriesDataForDropdown = () => {
    const COUNTRIES_ALL_DATA_JSON: CountriesAllDataAttributes = GetPreferredLanguageCountriesOptions();

    let countriesOptionList: CountryListType = {
        options: COUNTRIES_ALL_DATA_JSON.options.filter((country) => !DISABLED_COUNTRIES_IN_OPTION_LIST.includes(country.value))
    };
    return countriesOptionList;
};

export const GetDialingCodeOptions = (referredFrom) => {
    const COUNTRIES_ALL_DATA_JSON: CountriesAllDataAttributes = GetPreferredLanguageCountriesOptions();

    let dialingCodeOptions: CountryListType = {
        options: []
    };

    COUNTRIES_ALL_DATA_JSON.options.forEach((countryData) => {

        if (countryData.hasDialingCode) {
            let dialingCodeData: OptionObject = {
                displayName: referredFrom === 'selectList' ? countryData.countryNameWithDialcode : countryData.label,
                icon: countryData.icon,
                label: countryData.countryNameWithDialcode,
                value: countryData.dialingCode
            };
            dialingCodeOptions.options.push(dialingCodeData);
        }
    });
    return dialingCodeOptions;
};

export const GetDialingCodeObjectAsPerCountryCode = (countryCode: string) => {
    const COUNTRIES_ALL_DATA_JSON: CountriesAllDataAttributes = GetPreferredLanguageCountriesOptions();

    const dialingCodeOptions: CountriesAllDataObject[] = COUNTRIES_ALL_DATA_JSON.options.filter((countryData) => {
        return countryData.hasDialingCode && countryData.value === countryCode;
    });

    const dialingCodeOptionsObject: DialingCodeObj = {
        dialingCode: dialingCodeOptions[0]?.dialingCode,
        displayName: dialingCodeOptions[0]?.countryNameWithDialcode
    }

    return dialingCodeOptionsObject;
};

export const GetCountriesFlagIcon = async (Icon: string) => {
    const image = await import(`../../assets/CountriesList/${Icon}.svg`);
    return image;
};

export const GetCountryObjectAsPerCountryCode = (countryCode: string, countryData: CountriesApiObject[] | null) => {
    const COUNTRIES_ALL_DATA_JSON: CountriesApiObject[] | null = countryData;

    const countryCodeOptions: CountriesApiObject | null = COUNTRIES_ALL_DATA_JSON?.find((countryData) => {
        return countryData.countryIsoCode === countryCode;
    }) || null;

    return countryCodeOptions;
};

export const GetCurrenciesObjectAsPerCurrencyCode = (currencyCode: string, currencyData: CurrenciesAPIObject[] | null) => {
    const CURRENCIES_ALL_DATA_JSON: CurrenciesAPIObject[] | null = currencyData;

    const currencyCodeOptions: CurrenciesAPIObject | null = CURRENCIES_ALL_DATA_JSON?.find((currencyData) => {
        return currencyData.currencyCode === currencyCode;
    }) || null;

    return currencyCodeOptions;
};